import { MacBookWindow } from '@rumblefish/ui/Rumblefish23Theme';
import { scrollToElement } from '../../../utils/handleScroll';
import { contactFormId } from '../const';

export const Hero = () => {
  return (
    <>
      <MacBookWindow
        title={
          <>
            Zero-Knowledge Proof Development Services <br /> with Rumble Fish
          </>
        }
        description={
          <>Building privacy-preserving blockchain solutions that scale</>
        }
        buttonText="Let's talk!"
        buttonLink="/contact"
        buttonHandleOnClick={() => scrollToElement(contactFormId)}
        gradient="teal"
      />
    </>
  );
};
